import {DashboardConfig} from './types';

export const DEFAULT_WIDGET_ID = 99999;

export const DASHBOARD_CONFIGS: {
  [organizationId: string]: DashboardConfig[];
} = {
  ['DEFAULT_CONFIG']: [
    {
      id: 99999,
      // Rolling last 6 months
      startDate: new Date(new Date().setMonth(new Date().getMonth() - 6)).toISOString(),
      endDate: new Date().toISOString(),
      statAggregation: 'mean',
      layerKey: 'NDVI',
      sourceId: 'S2',
      title: 'Vegetation Vigor Analysis',
      timeAggregation: 'monthly',
      description: 'Average vegetation vigor over the last 6 months across all properties.',
      isPublished: true,
    },
  ],
};
